import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {AllBindingsAccessor} from '~knockout/index';
import {BindingContext} from '~knockout/index';
import {BindingHandlerControlsDescendant} from '~knockout/index';
import {playUiVoiceover} from '../audio/voiceovers/VoiceOverManager';

interface IParams
{
    callback: () => void;
    overFxID: string;
    clickFxID?: string;
    playOnTouch: boolean;
}

var isTouch: boolean;

/**
 * register our click or tap binding
 */
export function registerClickOrTapBinding()
{
    ko.bindingHandlers['clickOrTap'] =
        {
            init: function(element: HTMLElement, valueAccessor: () => IParams, allBindingsAccessor: AllBindingsAccessor, viewModel: any, bindingContext: BindingContext<any>)
            {
                //  mouse events

                element.addEventListener('touchend', () =>
                {
                    let fxID: string;

                    //  flag that we're using touch

                    isTouch = true;

                    if (element.dataset['state'] === 'hover') return valueAccessor().callback();

                    //  does the element have a click sfx?

                    fxID = valueAccessor().overFxID;

                    //  if so, play it

                    if (fxID) playUiVoiceover(fxID);

                    //  flag that the element is being hovered-over, after a short delay

                    setTimeout(() => element.dataset['state'] = 'hover', 50);

                    if (valueAccessor().playOnTouch) valueAccessor().callback();
                });

                element.addEventListener('mouseenter', () =>
                {
                    let fxID: string;

                    if (element.dataset['state'] === 'hover') return;

                    //  does the element have a click sfx?

                    fxID = valueAccessor().overFxID;

                    //  if so, play it

                    if (fxID) playUiVoiceover(fxID);

                    //  flag that the element is being hovered-over, after a short delay

                    setTimeout(() => element.dataset['state'] = 'hover', 100);
                });

                element.addEventListener('mouseleave', () =>
                {
                    //  reset its state

                    element.dataset['state'] = null;
                });

                element.addEventListener('mouseup', () =>
                {
                    //  if the element is not active then stop here

                    if (element.dataset['state'] !== 'hover' || isTouch) return;

                    //  call the element's callback function

                    valueAccessor().callback();
                });
            },
            update: function(element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: AllBindingsAccessor, viewModel: any, bindingContext: BindingContext<any>)
            {
                // This will be called once when the binding is first applied to an element,
                // and again whenever any observables/computeds that are accessed change
                // Update the DOM element based on the supplied values here.

            }
        };
}




// WEBPACK FOOTER //
// ./src/ts/components/InteractiveElementBinding.ts